<template>
  <div class="format0203">
    <div class="format-cover2" :style="$route.name === 'tools01-format' ? 'height: 600px;' : 'height: 150px;'">
      <div class="overlay-background" :style="`background:${formatData.color04};height:${formatData.height01}px;`">
        <div class="overlay-outline">
          <div class="image-cover">
            <img v-if="formatData.img == null || formatData.img == ''" :src="`${rt}/img/tools01/no-photo.png`"
              class="format-img" />
            <img v-else :src="`${rt}${uploadsFolder}${formatData.img}`" class="format-img" />
          </div>
          <div class="text-button-cover">
            <p v-html="sanitizeHtml(formatData.text01)"
              :style="`background-color: ${formatData.color01 === '#ffffff' ? 'transparent' : formatData.color01};`">
            </p>
            <div class="button" v-html="sanitizeHtml(formatData.text02)"
              :style="`width: ${formatData.width01}px; height: ${formatData.height02}px; background-color: ${formatData.color02 === '#ffffff' ? 'transparent' : formatData.color02};`">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Format0203",
  props: {
    formatData: Object,
  },
  data() {
    return {
      // 
    };
  },
  computed: {
    ...mapGetters(['rt', 'uploadsFolder']),
  },
};
</script>

<style lang="scss" scoped>
.format-cover2 {
  width: 375px;
  background: white;
  margin: auto;

  .overlay-background {
    width: 100%;
    height: 150px;
    box-sizing: border-box;
    bottom: 0;

    .overlay-outline {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1em;

      .image-cover {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30%;
        height: 100%;
        margin-right: 0.5em;

        .format-img {
          max-width: 100%;
          max-height: 100%;
          width: auto;
          height: auto;
        }
      }

      .text-button-cover {
        width: 70%;
        display: flex;
        flex-direction: column;
        align-items: center;

        p {
          margin: 0;
          text-align: center;
        }

        .button {
          margin-top: 0.5em;
          border-radius: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
</style>